import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const BoldIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 3H13.375C15.9293 3 18 5.07068 18 7.625C18 9.07883 17.3292 10.376 16.2802 11.2238C18.0339 12.0378 19.25 13.8144 19.25 15.875C19.25 18.7055 16.9555 21 14.125 21H4.5V3ZM6 4.5H13.375C15.1009 4.5 16.5 5.89911 16.5 7.625C16.5 9.35089 15.1009 10.75 13.375 10.75H6V4.5ZM6 12.25V19.5H14.125C16.127 19.5 17.75 17.877 17.75 15.875C17.75 13.873 16.127 12.25 14.125 12.25H6Z", fill: "currentColor" }));
//# sourceMappingURL=BoldIcon.js.map